import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, isEqual, isEmpty, includes, startCase, reduce, capitalize, partition } from 'lodash';
import moment from 'moment';
import Countdown, { zeroPad } from 'react-countdown';
import Cookie from 'universal-cookie';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import { formatDate, formatTime, getTimeInterval } from '../../utils/fudrLocalizationHelper';
import {
  browserList,
  cardStyles,
  installPopupReengageDelay,
  pwaInstallPopupDelay,
  socialPlatformAppCodes,
  toastMessageTime,
  apiResponseCodes,
  paymentTypes,
  currencies,
  orderStatusConfig,
  cashCardUnitPointMonetaryFactor,
  refundTypesConfig,
  serverErrorCodes,
  additionalDiscountCodeConfig,
  offerTypeCode,
} from '../../constants/globals';
import {
  getTableLabel,
  formatAddress,
  isInStandaloneMode,
  detectWebAppBrowser,
  extractWhitelabelSubdomain,
  getRestaurantEntitySocialLinkByCode,
  isUUID,
} from '../../utils/helpers';
import routes from '../../routes';
import {
  getOrderStatus,
  fetchOrderedItemsAction,
  clearViewCartItems,
  updateAssistanceStatusAction,
  clearApiErrorResponseAction,
  clearFetchOrderedItemsAction,
  fetchRestaurantDataAction,
  dispatchPreviousSelectedTableAction,
  dispatchVerifiedLocalitiesAction,
  dispatchSelectedAddressAction,
  dispatchUserCartAction,
  clearProgressiveWebAppDataAction,
  dispatchVisitedRestaurantsAction,
  dispatchProgressiveWebAppDataAction,
} from '../../actions/app.action';
import { fetchAppStartupInfoAction } from '../../actions/common';
import { updateProfileAction } from '../../actions/authentication';
import {
  selectRestaurant,
  renderOrderStatusImage,
  renderOrderStatus,
  renderOrderDescription,
  getErrorTitle,
  getErrorDescription,
  getButtonHandlerCta,
  getPaymentModeLabel,
  getPaymentStatus,
  getRefundModeLabel,
  getRefundStatusUpdateDate,
  getRefundStatus,
} from '../../selectors';
import { inHouseTableTypes } from '../../constants/globals';
import { constants } from '../../constants/configuration';
import { dateTimeFormats } from '../../utils/dateFormats';
import rewardsRoutes from '../../routes/rewards';

import './Confirmation.scss';
import directionIcon from '../../assets/images/icons/direction.svg';
import phoneIcon from '../../assets/images/icons/phone.svg';
import instagramBranding from '../../assets/images/instagram-branding.svg';
import facebookBranding from '../../assets/images/facebook-branding.svg';
import infoIcon from '../../assets/images/icons/info-icon.svg';

const Header = asyncRoute(() => import('../../components/Header'));
const Button = asyncRoute(() => import('../../components/elements/Button'));
const FoodItem = asyncRoute(() => import('../../components/FoodItem'));
const OfferedItemsCard = asyncRoute(() => import('../../components/Card/OfferedItemsCard'));
const CancelledItemsPopup = asyncRoute(() => import('../../components/Popup/CancelledItemsPopup'));
const Scratchcard = asyncRoute(() => import('../../components/Scratchcard'));
const Services = asyncRoute(() => import('../../components/Popup/Services'));
const ExceptionComponent = asyncRoute(() => import('../../components/ExceptionComponent'));
const UpdateProfileField = asyncRoute(() => import('../../components/Popup/UpdateProfileField'));
const ContactInfoPopup = asyncRoute(() => import('../../components/Popup/ContactInfo'));
const Footer = asyncRoute(() => import('../../components/Footer'));
const InstallAppetizerCard = asyncRoute(() => import('../../components/Card/InstallAppetizer'));
const InstallAppetizerPopup = asyncRoute(() => import('../../components/Popup/InstallAppetizer'));
const SafariPWAInstallGuide = asyncRoute(() =>
  import('../../components/Popup/InstallAppetizer/SafariGuide'),
);
const AdditionalChargesPopup = asyncRoute(() => import('../../components/Popup/AdditionalCharges'));
const AsyncImage = asyncRoute(() => import('../../components/elements/AsyncImage'));
const AuthenticationPopup = asyncRoute(() => import('../../components/Popup/AuthenticationPopup'));
const InstallAppCard = asyncRoute(() => import('../../components/Card/InstallApp'));
const InstallAppPopup = asyncRoute(() => import('../../components/Popup/InstallApp'));

let unattendedTimer = '';
const cookies = new Cookie();
const orderConfirmationScreenResources = constants.confirmation;

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderStatus: '',
      showCancelledItemsPopup: false,
      showScratchCard: false,
      showServicesComponent: false,
      showErrorPopup: false,
      showEnterEmailPopup: false,
      showContactInfoPopup: false,
      fieldType: '',
      errorContent: {
        title: '',
        description: '',
        buttonCta: '',
      },
      pageType: 'HalfSize',
      page: routes.containers.confirmation,
      showPWAInstallPopup: false,
      showSafariPWAInstallPopup: false,
      showAdditionalChargesPopup: false,
      showAuthenticationPopup: false,
      showInstallAppPopup: false,
    };
    this.scrollRef = React.createRef();
  }

  componentWillMount() {
    const {
      clearViewCartItems,
      dispatchPreviousSelectedTableAction,
      dispatchVerifiedLocalitiesAction,
      dispatchSelectedAddressAction,
      dispatchUserCart,
    } = this.props;
    clearViewCartItems();
    dispatchPreviousSelectedTableAction();
    dispatchVerifiedLocalitiesAction();
    dispatchSelectedAddressAction();
    dispatchUserCart({});
  }

  componentDidUpdate(prevProps) {
    const currentAccessToken = this.props.accessToken;
    const previousAccessToken = prevProps.accessToken;

    // Upon login after the app load
    if (!isEmpty(currentAccessToken) && !isEqual(currentAccessToken, previousAccessToken)) {
      this.setState({ showAuthenticationPopup: false }, () => {
        this.initiateActionAfterAuthentication({
          accessToken: currentAccessToken,
        });
      });
    }
    // check if assistances are updated
    const { isAssistanceUpdated } = this.props;
    if (isAssistanceUpdated) {
      const assistanceElement = document.getElementById('assistance-success');
      if (assistanceElement) {
        setTimeout(function () {
          document.getElementById('assistance-success').style.visibility = 'hidden';
        }, toastMessageTime);
      }
    }
  }

  componentDidMount() {
    const { orderStatus, accessToken } = this.props;
    this.props.clearFetchOrderedItemsAction(); // clear already stored ordered Items on component mount

    if (!isEmpty(orderStatus)) {
      this.setState({
        orderStatus,
      });
    }
    !isEmpty(accessToken) && this.initiateActionAfterAuthentication({ accessToken });
  }

  initiateActionAfterAuthentication = ({ accessToken }) => {
    const { updateAssistanceStatusAction, match, history } = this.props;
    const orderId = get(match, 'params.orderId', '');
    // fetch order item data
    if (!isEmpty(orderId) && !isEmpty(accessToken)) {
      this.props.fetchOrderedItemsAction({ orderId, accessToken }).then((offeredItemsResponse) => {
        if (apiResponseCodes.SUCCESS.includes(get(offeredItemsResponse, 'status', ''))) {
          const restaurantId = get(offeredItemsResponse, 'data.restaurantId', '');
          if (!isEmpty(restaurantId)) {
            // fetch restaurnat data if restaurantId is not empty
            this.props
              .fetchRestaurantDataAction({ restaurantId })
              .then((restaurantDataResponse) => {
                if (apiResponseCodes.SUCCESS.includes(get(restaurantDataResponse, 'status', ''))) {
                  // Fetch whitelabel app data if the whitelabelSubDomain exists for the outlet
                  let whitelabelSubDomain = get(restaurantDataResponse, 'data.subDomain', '');
                  if (isEmpty(whitelabelSubDomain)) {
                    whitelabelSubDomain = get(restaurantDataResponse, 'data.engageBrand', '');
                  }

                  const appStartupReqBody = {
                    subdomain: whitelabelSubDomain,
                    includeModules: ['whiteLabelApp', 'reward', 'brand', 'resource'],
                  };
                  whitelabelSubDomain &&
                    this.props.fetchAppStartupInfo({ appStartupReqBody }).then((response) => {
                      if (apiResponseCodes.SUCCESS.includes(get(response, 'status', ''))) {
                        const progressiveWebAppData = get(response, 'data.whiteLabelApp', {});
                        this.props.dispatchProgressiveWebAppData({
                          progressiveWebAppData,
                        });
                      }
                    });

                  // Dispatch visited restaurant to the redux store if the guest visits the restaurant's order confirmation page, implying that the guest has previously visited and ordered from this restaurant
                  const { guestData } = this.props;
                  const guestId = get(guestData, 'id');
                  const guestVisitedRestaurants = get(guestData, 'visitedRestaurants', []);
                  const currentlyVisitedRestaurantCode = get(
                    restaurantDataResponse,
                    'data.restaurantCode',
                  );

                  if (
                    guestId &&
                    !guestVisitedRestaurants.includes(currentlyVisitedRestaurantCode)
                  ) {
                    this.props.dispatchVisitedRestaurants([
                      ...guestVisitedRestaurants,
                      currentlyVisitedRestaurantCode,
                    ]);
                  }
                }
              });
          }
        }
      });
    }

    unattendedTimer = (
      <Countdown
        date={getTimeInterval(constants.unattendedTimer)}
        renderer={({ minutes, seconds }) => (
          <strong>
            {zeroPad(minutes)}:{zeroPad(seconds)}
          </strong>
        )}
      />
    );
    updateAssistanceStatusAction();

    // Check if it's a whitelabel subdomain entry
    if (extractWhitelabelSubdomain()) {
      // Open PWA install popup with a delay keeping in mind that all the PWA installability criteria are met
      // If install promo timestamp cookie does not exist, then show the PWA install popup
      if (!cookies.get('lastInstallPromoTimestamp')) {
        setTimeout(() => this.onOpenPWAInstallPopup(), pwaInstallPopupDelay);
      } else {
        // Check if certain time has passed after the set install promo timestamp. If yes, show the PWA install popup.
        const breakOver =
          Date.now() - cookies.get('lastInstallPromoTimestamp') >= installPopupReengageDelay;
        if (breakOver) setTimeout(() => this.onOpenPWAInstallPopup(), pwaInstallPopupDelay);
      }
    }

    // If the initiator route is the confimation screen itself, then modify browser back behavior
    if (get(history, 'location.state.initiatorRoute') === `/${routes.containers.confirmation}`) {
      const { selectedTable } = this.props;
      const scanCode = get(selectedTable, 'scanCode', '');

      window.onpopstate = (event) => {
        // Block the browser back propagation and confirm if the guest wants to navigate to menu, or stay on the same route
        window.confirm(orderConfirmationScreenResources.backToMenuConfirm)
          ? history.push(`/${routes.containers.restaurant}/${scanCode}`)
          : window.history.go(1);
      };
    }

    // Scroll to top to prevent browser scroll position persistence from other screens
    window.scrollTo({ top: 0 });
  };

  componentWillReceiveProps(nextProps) {
    const { getOrderStatus, orderedItems, accessToken } = this.props;
    const { tableType } = orderedItems;
    if (
      !isEqual(get(this.props, 'orderedItems', {}), get(nextProps, 'orderedItems', {})) &&
      !isEmpty(get(nextProps, 'orderedItems', {}))
    ) {
      const type = get(nextProps, 'orderedItems.tableType', '');
      const statusCode = get(nextProps, 'orderedItems.statusCode', '');
      const orderId = get(nextProps, 'orderedItems.id', '');

      if (!includes(inHouseTableTypes, type)) {
        // check if tableType doesn't includes in inHouseTableTypes
        if (
          isEqual(statusCode, 'UNATTENDED') ||
          (isEqual(statusCode, 'CONFIRMED') && !this.timer)
        ) {
          this.timer = setInterval(() => getOrderStatus(orderId), 2000);
        }
      } else {
        if (isEqual(statusCode, 'UNATTENDED') && !this.timer) {
          this.timer = setInterval(() => getOrderStatus(orderId), 2000);
        }
      }
    }

    if (
      !isEqual(get(this.props, 'orderStatus', ''), get(nextProps, 'orderStatus', '')) &&
      !isEmpty(get(nextProps, 'orderStatus', ''))
    ) {
      const orderStatus = get(nextProps, 'orderStatus', '');
      const orderId = get(nextProps, 'orderedItems.id', '');
      this.setState(
        {
          orderStatus,
        },
        () => {
          //check if the updated status is not unattended status. Stop polling and get updated order
          if (isEqual(orderStatus, 'CONFIRMED')) {
            //if status is confirmed. Fetch ordered items updated response
            this.props.fetchOrderedItemsAction({ orderId, accessToken });
            if (includes(inHouseTableTypes, tableType)) {
              // check if tableType includes in inHouseTableTypes then stop polling
              clearInterval(this.timer);
            }
          } else if (isEqual(orderStatus, 'CANCELLED')) {
            //if status is cancelled. Fetch ordered items cancel reason
            this.props.fetchOrderedItemsAction({ orderId, accessToken });
            //stop polling when order is cancelled
            clearInterval(this.timer);
          } else if (!includes(constants.orderConfirm.orderUnattendedStatuses, orderStatus)) {
            clearInterval(this.timer);
          }
        },
      );
    }

    //check if login data is updated
    if (
      !isEqual(get(this.props, 'loginData'), get(nextProps, 'loginData')) &&
      !isEmpty(get(nextProps, 'loginData'))
    ) {
      this.setState({
        showEnterEmailPopup: false,
        fieldType: '',
      });
    }

    // check if api throwrs error
    if (
      !isEmpty(get(nextProps, 'errorResponse')) &&
      !isEqual(get(this.props, 'errorResponse'), get(nextProps, 'errorResponse'))
    ) {
      const { code, message } = nextProps.errorResponse;

      if (isEqual(message, 'Invalid guest order id')) {
        this.setState({
          showErrorPopup: true,
          showCancelledItemsPopup: false,
          showScratchCard: false,
          showServicesComponent: false,
          showEnterEmailPopup: false,
          showContactInfoPopup: false,
          pageType: 'FullSize',
          errorContent: {
            title: getErrorTitle({ code }),
            description: getErrorDescription({ code, message }),
            buttonCta: 'BACK TO SCAN',
          },
        });
      } else if (code === 'UNAUTHORIZED_ACTION') {
        this.setState({
          showErrorPopup: true,
          pageType: 'HalfSize',
          errorContent: {
            title: getErrorTitle({ source: orderConfirmationScreenResources, code }),
            description: getErrorDescription({
              source: orderConfirmationScreenResources,
              code,
              message,
            }),
            buttonCta: getButtonHandlerCta({ source: orderConfirmationScreenResources, code }),
          },
        });
      } else if (code === 'OTP_INVALID') {
        this.setState({
          showErrorPopup: true,
          pageType: 'HalfSize',
          errorContent: {
            title: getErrorTitle({ source: orderConfirmationScreenResources, code }),
            description: getErrorDescription({
              source: orderConfirmationScreenResources,
              code,
              message,
            }),
            buttonCta: getButtonHandlerCta({ source: orderConfirmationScreenResources, code }),
          },
        });
      } else {
        this.setState({
          showErrorPopup: true,
          pageType: 'HalfSize',
          errorContent: {
            title: getErrorTitle({ code }),
            description: getErrorDescription({ code, message }),
            buttonCta: getButtonHandlerCta({ code }),
          },
        });
      }

      // Hide the error popup if the whitelabel app is not found
      if (code === serverErrorCodes.notFound) {
        this.setState({
          showErrorPopup: false,
        });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.props.clearFetchOrderedItemsAction();
    this.props.clearApiErrorResponseAction();
    unattendedTimer = '';

    this.props.clearProgressiveWebAppData();
  }

  onBackToMenuClick = () => {
    const { selectedTable } = this.props;

    const scanCode = get(selectedTable, 'scanCode', '');
    let currentRestaurantCode = `/${routes.containers.restaurant}/${scanCode}`;

    window.location.replace(window.location.origin + currentRestaurantCode);
  };

  viewCancelledItemsClick = () => {
    this.setState({
      showCancelledItemsPopup: true,
    });
  };

  dismissCancelledItemsPopup = () => {
    this.setState({
      showCancelledItemsPopup: false,
    });
  };

  onBackClick = () => {
    const { history } = this.props;
    history && history.goBack();
  };

  handleScratchCardCallback = () => {
    this.setState({
      showScratchCard: false,
    });
  };

  handleServicesClick = () => {
    const { updateAssistanceStatusAction } = this.props;
    updateAssistanceStatusAction().then(() => {
      this.setState({
        showServicesComponent: true,
      });
    });
  };

  onCloseServicesComponent = () => {
    this.setState({
      showServicesComponent: false,
    });
  };

  onCloseExceptionComponent = () => {
    this.props.clearApiErrorResponseAction().then(() => {
      this.setState({
        showErrorPopup: false,
        showServicesComponent: false,
      });
    });
  };

  handleErrorBtnCTA = () => {
    const { code } = this.props.errorResponse;
    switch (code) {
      case 'UNAUTHORIZED_ACTION':
        this.setState({ showErrorPopup: false });
        this.setState({ showAuthenticationPopup: true });
        break;
      case 'OTP_INVALID':
        this.setState({ showErrorPopup: false });
        break;
      default:
        this.props.history.push(`/${routes.containers.scan}`);
        break;
    }
  };

  onClickEnterEmailLink = () => {
    this.setState({
      showEnterEmailPopup: true,
      fieldType: 'email',
    });
  };

  onCloseEnterEmailPopup = () => {
    this.setState({
      showEnterEmailPopup: false,
    });
  };

  handleEmailUpdateCTA = (formFieldsState) => {
    const { loginData } = this.props;
    const { id: guestId } = loginData;
    this.props.updateProfileAction(formFieldsState, guestId);
  };

  handleGetDirection = () => {
    const { restaurantConfig } = this.props;
    const directionLink = get(restaurantConfig, 'directionLink', '');
    window.open(directionLink, '_blank');
  };

  handlePhoneIconClick = () => {
    this.setState({
      showContactInfoPopup: true,
    });
  };

  renderPhoneSection = (restaurantContactNumbers) => {
    if (restaurantContactNumbers && restaurantContactNumbers.length === 1) {
      const contactNumber = get(restaurantContactNumbers, '0.phoneNumber', '');
      let href = `tel:${contactNumber}`;
      return (
        <a href={href}>
          <img src={phoneIcon} alt="phone" />
        </a>
      );
    } else {
      return <img src={phoneIcon} alt="phone" onClick={this.handlePhoneIconClick} />;
    }
  };

  onCloseContactInfoPopup = () => {
    this.setState({
      showContactInfoPopup: false,
    });
  };

  onOpenPWAInstallPopup = () => {
    this.setState({ showPWAInstallPopup: true });
  };

  onClosePWAInstallPopup = () => {
    this.setState({ showPWAInstallPopup: false }, () =>
      cookies.set('lastInstallPromoTimestamp', Date.now()),
    ); // Set the current timestamp into lastInstallPromoTimestamp cookie to later re-engage the user after certain time
  };

  setShowSafariPWAInstallPopup = (showPopup = false) => {
    this.setState({ showSafariPWAInstallPopup: showPopup });
  };

  handleSafariPWAInstallClick = (whitelabelInfoExists, showPopup = false) => {
    const isPWADirectlyInstallable = whitelabelInfoExists;
    isPWADirectlyInstallable ? this.setShowSafariPWAInstallPopup(showPopup) : this.openGetPWALink();
  };

  handleInstallPWAClick = (whitelabelInfoExists) => {
    const isPWADirectlyInstallable = whitelabelInfoExists;
    isPWADirectlyInstallable ? this.props.handleInstallPWAClick() : this.openGetPWALink();
  };

  openGetPWALink = () => {
    const appLink = get(this.props, 'progressiveWebApp.appLink', '');
    appLink && window.open(appLink, '_blank').focus(); // Open outlet's get-app link in a new tab
  };

  handleAdditionalChargesInfoIconClick = () => this.setState({ showAdditionalChargesPopup: true });

  handleCloseAdditionalChargesPopup = () => this.setState({ showAdditionalChargesPopup: false });

  onCloseAuthenticationPopup = () => {
    this.setState({
      showAuthenticationPopup: false,
    });
  };

  prepareOrderOffersDOM = (orderOffers) => {
    const [guestAppliedOffers, outletAppliedOffers] = partition(
      orderOffers,
      (orderOffer) => !get(orderOffer, 'isOutletApplied', false),
    );

    const guestAppliedOffersDOMArray = guestAppliedOffers.map((offer, index) => (
      <div className="confirmation_appliedOffer guest-applied" key={get(offer, 'offerId', index)}>
        {get(offer, 'code', '') && (
          <div className="confirmation_appliedOffer_dealImageSection">
            <AsyncImage sourceUrl={get(offer, 'offerImage', '')} altText={get(offer, 'code', '')} />
          </div>
        )}
        <div className="confirmation_appliedOffer_offerCode"> {get(offer, 'code', '')}</div>
      </div>
    ));

    const outletAppliedOffersDOMArray = outletAppliedOffers.map((offer, index) => (
      <div className="confirmation_appliedOffer outlet-applied" key={get(offer, 'offerId', index)}>
        {additionalDiscountCodeConfig.stub}
      </div>
    ));

    const combinedDOMArray = [...guestAppliedOffersDOMArray, ...outletAppliedOffersDOMArray];
    return !isEmpty(combinedDOMArray) ? (
      <div className="confirmation_appliedOffer-wrapper">{combinedDOMArray}</div>
    ) : (
      <></>
    );
  };

  renderOfferedItemsCard = (orderedItems) => {
    const offeredItems = get(orderedItems, 'offeredItems', []);

    if (!isEmpty(get(orderedItems, 'orderOffers', []))) {
      const [orderOffer] = orderedItems.orderOffers;
      if (get(orderOffer, 'type', '') === offerTypeCode.ItemFree) {
        const freeItemName = get(orderOffer, 'description', '');

        return (
          <div className="offered-items-card">
            <div className="offered-items-card_title">{constants.card.offeredItemsCard.title}</div>
            <div className="offered-items-card-item-section">
              <div className="free-item-name">{freeItemName}</div>
              <div className="free-item-instructions">
                Please contact restaurant for your choice of free item
              </div>
            </div>
          </div>
        );
      }
    }

    return (
      offeredItems && offeredItems.length > 0 && <OfferedItemsCard offeredItems={offeredItems} />
    );
  };

  handleLoginInClick = () => {
    this.setState({
      showAuthenticationPopup: true,
    });
  };

  setShowInstallAppPopup = (flag) => {
    this.setState({
      showInstallAppPopup: flag,
    });
  };

  handleInstallAppClick = () => {
    const { appStartupInfo } = this.props;
    const subDomain = get(appStartupInfo, 'subdomain', '');
    if (!isEmpty(subDomain)) {
      const getAppLink = `https://${subDomain}.fudr.in/${rewardsRoutes.rewards}/${rewardsRoutes.containers.getApp}`;
      this.setShowInstallAppPopup(true);
      this.setState({
        getAppLink,
      });
    }
  };

  render() {
    const {
      orderStatus,
      showCancelledItemsPopup,
      showScratchCard,
      showServicesComponent,
      showErrorPopup,
      errorContent,
      pageType,
      showEnterEmailPopup,
      showContactInfoPopup,
      fieldType,
      page,
      showPWAInstallPopup,
      showSafariPWAInstallPopup,
      showAdditionalChargesPopup,
      showAuthenticationPopup,
      showInstallAppPopup,
      getAppLink,
    } = this.state;
    const {
      history,
      orderedItems,
      restaurantConfig,
      restaurant,
      isAssistanceUpdated,
      loginData,
      restaurantPhoneNumbers,
      pwaFeatureEnabled, // Soft-config to turn PWA feature on/off
      enablePWAInstallWidgets,
      handleInstallPWAClick,
      appStartupInfo,
      restaurantGroup,
      progressiveWebApp,
      accessToken,
    } = this.props;

    const { defaultPreparationTime } = restaurantConfig;

    const {
      orderNumber,
      items,
      totalAmount,
      guest,
      customization,
      orderPunchTime,
      orderPrefix,
      cancelledItems,
      deliveryLocation,
      tableLabel,
      restaurantName,
      orderOffers,
      paymentType,
      tableType,
      tableTitle,
      ePrepTime,
      ePickupTime,
      isTaxInclusive,
      additionalCharges,
      taxAmount,
      transactions,
      refundTransactions,
      hasPointsPayment,
      netBalance,
      pointTransactions,
      pointRefundTransactions,
      deliveryCharges,
      effectiveDeliveryAmount,
      deliveryDiscount,
    } = orderedItems;

    const initiatorRoute = get(history, 'location.state.initiatorRoute', '');
    const orderDay = moment(orderPunchTime).format('DD MMM YY');
    const orderTime = moment(orderPunchTime).format('LTS');
    const restaurantContactNumbers =
      restaurantPhoneNumbers.length > 0 &&
      restaurantPhoneNumbers.filter(
        (phoneNumber) => get(phoneNumber, 'isVisibleOnMenu', false) === true,
      );
    const offeredItems = get(orderedItems, 'offeredItems', []);

    const renderOrderItems = (items) =>
      items.map((menuItem, index) => (
        <FoodItem
          key={`${menuItem.menuItemId}~${index}`}
          name={menuItem.menuItemName}
          price={menuItem.effectivePrice}
          description={menuItem.description}
          img={menuItem.img}
          count={menuItem.quantity}
          menuItem={menuItem}
          type={menuItem.type}
          isEnabled
          customizedItems={menuItem.orderCustomizations}
          infoType
        />
      ));

    // PWA widgets display handling flags
    const whitelabelInfoExists = !isEmpty(appStartupInfo.whiteLabelApp);
    const subDomain = extractWhitelabelSubdomain();
    let whitelabelAppDataExists = false; // fallback
    whitelabelAppDataExists = subDomain
      ? !isEmpty(get(appStartupInfo, 'whiteLabelApp'))
      : !isEmpty(progressiveWebApp);
    const pwaDiscoveryCriteria =
      (subDomain ? whitelabelInfoExists : true) && whitelabelAppDataExists; // Ensure the whitelabel info and whitelabel app data exists as a criteria to make PWA widgets visible
    const isRewardAppAvailable = isEqual(get(appStartupInfo, 'rewardProgram.status'), 'ACTIVE');
    let showPWAInstallCard =
      pwaFeatureEnabled && enablePWAInstallWidgets && pwaDiscoveryCriteria && !isRewardAppAvailable;
    let showPWAInstallPopupFlag =
      pwaFeatureEnabled &&
      enablePWAInstallWidgets &&
      showPWAInstallPopup &&
      pwaDiscoveryCriteria &&
      !isRewardAppAvailable;
    const browserInfo = detectWebAppBrowser();
    const isSafari = !isEmpty(browserInfo) && browserInfo['name'] === browserList.iOSSafari;

    let showSafariPWAInstallPopupFlag = false;
    if (isSafari) {
      if (!isInStandaloneMode()) {
        // not in standalone mode implies the webapp has been opened in Safari on iOS
        showPWAInstallCard = pwaFeatureEnabled && pwaDiscoveryCriteria;
        showPWAInstallPopupFlag = pwaFeatureEnabled && showPWAInstallPopup && pwaDiscoveryCriteria;
        showSafariPWAInstallPopupFlag =
          pwaFeatureEnabled && showSafariPWAInstallPopup && pwaDiscoveryCriteria;
      } else {
        // in standalone mode implies the webapp has been opened in PWA on iOS
        showPWAInstallCard = false;
        showPWAInstallPopupFlag = false;
        showSafariPWAInstallPopupFlag = false;
      }
    }

    const isRestaurantGroupScope = get(appStartupInfo, 'subdomainObj.isGroup', false);
    let restaurantEntityName = '',
      restaurantEntityImage = '',
      restaurantEntityInstaLink = '',
      restaurantEntityFBLink = '';

    // Extract whitelabel app related data
    const { appName, appIconUrl } = subDomain
      ? get(appStartupInfo, 'whiteLabelApp', {})
      : progressiveWebApp;

    // Use the app name if it has been provided by the brand admin, else use restaurant's/group's name
    restaurantEntityName = !isEmpty(appName)
      ? appName
      : isRestaurantGroupScope
      ? get(restaurantGroup, 'name', '')
      : get(restaurant, 'name', '');

    // Use the app image if it has been provided by the brand admin, else use restaurant's/group's image
    restaurantEntityImage = !isEmpty(appIconUrl)
      ? appIconUrl
      : isRestaurantGroupScope
      ? ''
      : get(restaurant, 'restaurantConfig.logoUrl', '');

    if (whitelabelInfoExists) {
      const restaurantEntityConfig = isRestaurantGroupScope
        ? get(restaurantGroup, 'restaurantGroupConfig', {})
        : get(restaurant, 'restaurantConfig', {});
      const { additionalProperties: restaurantAdditionalProperties } = restaurantEntityConfig;
      restaurantEntityInstaLink = getRestaurantEntitySocialLinkByCode(
        socialPlatformAppCodes.instagram,
        restaurantAdditionalProperties,
      );
      restaurantEntityFBLink = getRestaurantEntitySocialLinkByCode(
        socialPlatformAppCodes.facebook,
        restaurantAdditionalProperties,
      );
    }

    // Order payment details
    const genericPayments = [];
    paymentType === paymentTypes.PREPAYMENT &&
      !isEmpty(transactions) &&
      genericPayments.push(...transactions);
    paymentType === paymentTypes.POSTPAYMENT &&
      genericPayments.push({
        amount: hasPointsPayment ? netBalance : totalAmount, // For cash-card + postpaid payment, postpaid amount should be net balance otherwise the order total
      });

    const loyaltyPayments = [];
    hasPointsPayment && !isEmpty(pointTransactions) && loyaltyPayments.push(...pointTransactions);

    const showPaymentDetails =
      !isEmpty(genericPayments) || (hasPointsPayment && !isEmpty(pointTransactions));

    // Order payment refund details, if any refund has been generated
    const genericRefunds = refundTransactions;
    const loyaltyRefunds = pointRefundTransactions;

    const showRefundDetails = !isEmpty(genericRefunds) || !isEmpty(loyaltyRefunds);

    const showHeaderBackButton =
      !isEmpty(initiatorRoute) && initiatorRoute !== `/${routes.containers.confirmation}`;

    const orderOffersDOM = this.prepareOrderOffersDOM(orderOffers);

    const memberId = get(orderedItems, 'additionalData.memberId', '');

    const discountAmount =
      get(orderOffers, 'length', 0) > 0
        ? reduce(orderOffers, (a, c) => a + c.discountAmount, 0)
        : 0;

    return (
      <>
        {showScratchCard && (
          <Scratchcard
            showScratchCard={showScratchCard}
            handleScratchCardCallback={this.handleScratchCardCallback.bind(this)}
          />
        )}
        <Header
          restaurant={restaurant}
          onBackClick={this.onBackClick}
          identifier={routes.containers.confirmation}
          initiatorRoute={initiatorRoute}
          showBackBtn={showHeaderBackButton}
          handleServicesClick={this.handleServicesClick.bind(this)}
          tableType={tableType}
        />
        {/* request assistance success toast message */}
        <>
          {
            <div className="confirmation" id="confirmation-wrapper">
              {!isEmpty(accessToken) ? (
                <>
                  {isAssistanceUpdated && (
                    <div
                      className="confirmation_request-assistance-success"
                      id="assistance-success"
                    >
                      {constants.services.toastMessage}
                    </div>
                  )}
                  <div className="confirmation_order-status-section">
                    {renderOrderStatusImage({
                      orderStatus,
                      cancelledItems,
                      tableType,
                    })}
                    <div className="confirmation_orderStatus">
                      {renderOrderStatus({
                        orderStatus,
                        cancelledItems,
                        tableType,
                      })}
                      {!isEmpty(get(orderedItems, 'cancelRemark', '')) && (
                        <div className="cancellation-remark">
                          {`"${get(orderedItems, 'cancelRemark', '')}"`}
                        </div>
                      )}
                    </div>
                    <div className="confirmation_orderDescription">
                      {renderOrderDescription({
                        orderStatus,
                        cancelledItems,
                        unattendedTimer,
                        tableType,
                        ePrepTime,
                        ePickupTime,
                        orderPunchTime,
                        defaultPreparationTime,
                      })}
                    </div>
                    {(isEqual(orderStatus, orderStatusConfig.UNATTENDED) ||
                      isEqual(orderStatus, orderStatusConfig.CONFIRMED) ||
                      isEqual(orderStatus, orderStatusConfig.SETTLED)) &&
                      cancelledItems &&
                      cancelledItems.length > 0 && (
                        <div className="confirmation_viewCancelledItems">
                          <Button
                            onClick={this.viewCancelledItemsClick}
                            content={constants.confirmation.viewCancelledItems}
                          />
                        </div>
                      )}
                    {isEqual(initiatorRoute, `/${routes.containers.confirmation}`) &&
                      !isEqual(orderStatus, 'UNATTENDED') && (
                        <div className="confirmation_backToMenuBtn">
                          <Button
                            onClick={this.onBackToMenuClick}
                            content={constants.confirmation.backToMenu}
                          />
                        </div>
                      )}
                  </div>
                  {isEqual(initiatorRoute, `/${routes.containers.confirmation}`) &&
                    isEmpty(loginData.email) && (
                      <>
                        <span className="item-line-break" />
                        <div className="confirmation_notification-email">
                          <span className="text">{constants.confirmation.enterEmail.text}</span>
                          <span className="link" onClick={this.onClickEnterEmailLink}>
                            {constants.confirmation.enterEmail.link}
                          </span>
                        </div>
                      </>
                    )}
                  {showPWAInstallCard && !isRewardAppAvailable && (
                    <InstallAppetizerCard
                      style={cardStyles.tablet}
                      restaurantEntityName={restaurantEntityName}
                      restaurantEntityImage={restaurantEntityImage}
                      handleInstallClick={() =>
                        isSafari
                          ? this.handleSafariPWAInstallClick(whitelabelInfoExists, true)
                          : this.handleInstallPWAClick(whitelabelInfoExists)
                      }
                      handleBrandClick={this.onOpenPWAInstallPopup}
                    />
                  )}
                  {isRewardAppAvailable && (
                    <InstallAppCard
                      style={cardStyles.tablet}
                      appStartupInfo={appStartupInfo}
                      onInstallAppClick={this.handleInstallAppClick}
                    />
                  )}
                  <span className="line-break" />
                  <span className="line-break" />
                  {
                    <div className="confirmation_restaurant-section">
                      <div>
                        <div className="restaurant-name">{restaurantName}</div>
                        <div className="icon-section">
                          {isEqual(tableType, 'SP') &&
                            !isEmpty(get(restaurantConfig, 'directionLink', '')) && (
                              <img
                                src={directionIcon}
                                alt="direction"
                                onClick={this.handleGetDirection}
                              />
                            )}
                          {restaurantContactNumbers &&
                            restaurantContactNumbers.length > 0 &&
                            this.renderPhoneSection(restaurantContactNumbers)}
                        </div>
                      </div>
                      {(isEqual(tableType, 'SP') || isEqual(tableType, 'DL')) && (
                        <div className="restaurant-address">{get(restaurant, 'address', '')}</div>
                      )}
                    </div>
                  }
                  {isEqual(tableType, 'DL') && (
                    <div className="confirmation_delivery-address">
                      <span className="deliveryText">{constants.confirmation.deliveryAddress}</span>
                      <div className="address">
                        {formatAddress(get(deliveryLocation, 'guestAddress', {}))}
                      </div>
                    </div>
                  )}
                  <div className="confirmation_orderTime">{`${orderDay} ${orderTime}`}</div>
                  <div className="confirmation_orderNumber">
                    {constants.confirmation.orderNumberText} {orderNumber}
                  </div>
                  {
                    <div className="confirmation_orderLocation">
                      {getTableLabel(tableType, tableTitle, tableLabel)}
                    </div>
                  }
                  <div className="confirmation_guestInformation">
                    <div className="guestName">{startCase(get(guest, 'name', 'Guest'))}</div>
                    <div className="guestDetails">{`+${get(guest, 'countryCode')}  ${get(
                      guest,
                      'primaryPhoneNumber',
                    )}`}</div>
                    {memberId && <div className="membership-details">Member ID: {memberId}</div>}
                    {isEqual(tableType, 'DT') && !isEmpty(deliveryLocation) && (
                      <div className="guestDetails">{`${get(
                        deliveryLocation,
                        'guestVehicle.vehicleNumber',
                      )} ${get(deliveryLocation, 'guestVehicle.identification')}`}</div>
                    )}
                  </div>
                  {customization && (
                    <div className="confirmation_special-instruction">
                      <div className="description">
                        <b>{constants.confirmation.specialInstructionText}</b> : {customization}
                      </div>
                    </div>
                  )}
                  {items && items.length > 0 && <div>{renderOrderItems(items)}</div>}
                  {this.renderOfferedItemsCard(orderedItems)}
                  {isEqual(orderStatus, 'CANCELLED') &&
                    cancelledItems &&
                    cancelledItems.length > 0 && <div>{renderOrderItems(cancelledItems)}</div>}
                  <span className="item-line-break" />
                  {orderOffersDOM}
                  <div className="confirmation_orderTotal">
                    <div>
                      <span>
                        {constants.cart.total} &nbsp;
                        <span className="confirmation_taxes">
                          {additionalCharges && additionalCharges > 0
                            ? constants.cart.includingTaxesAndServiceCharges
                            : constants.cart.includingTaxes}
                        </span>
                      </span>
                      <img
                        className="info-icon"
                        src={infoIcon}
                        onClick={this.handleAdditionalChargesInfoIconClick}
                        alt="i"
                      />
                    </div>

                    <div className="totalAmount-section">
                      <span>{`${currencies.INR.symbol} ${totalAmount}`}</span>
                    </div>
                  </div>
                  {discountAmount > 0 && (
                    <span className="confirmation_discount">{`${constants.offers.discountText} ${currencies.INR.symbol} ${discountAmount}`}</span>
                  )}
                  <span className="line-break" />
                  <span className="line-break" />
                  {/** Order stats section */}
                  <div className="confirmation_order-stats">
                    <div className="stats-section">
                      <span className="text">{constants.confirmation.orderId}</span>
                      <span className="value">{`${orderPrefix}-${orderNumber}`}</span>
                    </div>
                    {isEqual(tableType, 'SP') && (
                      <>
                        {ePickupTime > 0 && (
                          <div className="stats-section">
                            <span className="text">{constants.confirmation.eta}</span>
                            <span className="value">
                              {formatTime(orderPunchTime, ePickupTime)}
                              <br />
                              {constants.confirmation.estimatedTimeOfArrival}
                            </span>
                          </div>
                        )}
                        {!isEqual(orderStatus, 'UNATTENDED') && (
                          <div className="stats-section">
                            <span className="text">{constants.confirmation.etd}</span>
                            <span className="value">
                              {formatTime(orderPunchTime, ePrepTime)}
                              <br />
                              {constants.confirmation.estimatedTimeOfDelivery}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="line-break" />
                  {/** Order transaction details */}
                  <div className="confirmation_transaction-details">
                    {showPaymentDetails && (
                      <div className="payment-details row">
                        <div className="title">
                          {orderConfirmationScreenResources.paymentDetails.title}
                        </div>
                        <div className="content">
                          <PaymentDetailsRow
                            payments={genericPayments}
                            paymentMode={paymentType}
                            orderStatus={orderStatus}
                          />
                          {!!hasPointsPayment && (
                            <PaymentDetailsRow
                              payments={loyaltyPayments}
                              paymentMode={paymentTypes.loyaltyPaymentTypes.CASHCARD}
                              orderStatus={orderStatus}
                            />
                          )}
                        </div>
                      </div>
                    )}
                    {showRefundDetails && (
                      <div className="refund-details row">
                        <div className="title">
                          {orderConfirmationScreenResources.refundDetails.title}
                        </div>
                        <div className="content">
                          <RefundDetailsRow
                            refunds={genericRefunds}
                            refundMode={refundTypesConfig.prepaid}
                          />
                          <RefundDetailsRow
                            refunds={loyaltyRefunds}
                            refundMode={refundTypesConfig.loyaltyRefundTypes.CASHCARD}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {(!!restaurantEntityInstaLink || !!restaurantEntityFBLink) && (
                    <Footer className="restaurant-social-links">
                      <div className="social-links-inner-wrapper">
                        {!!restaurantEntityInstaLink && (
                          <a
                            className="social-link"
                            href={restaurantEntityInstaLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={instagramBranding} alt="Instagram" />
                          </a>
                        )}
                        {!!restaurantEntityFBLink && (
                          <a
                            className="social-link"
                            href={restaurantEntityFBLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={facebookBranding} alt="Facebook" />
                          </a>
                        )}
                      </div>
                    </Footer>
                  )}
                  {showCancelledItemsPopup && (
                    <CancelledItemsPopup
                      openSegmentPopup={showCancelledItemsPopup}
                      classList="confirmation_cancelled-items"
                      dismissSegmentPopup={this.dismissCancelledItemsPopup}
                    />
                  )}
                  {!isAssistanceUpdated && showServicesComponent && (
                    <Services
                      openSegmentPopup={showServicesComponent}
                      dismissSegmentPopup={this.onCloseServicesComponent.bind(this)}
                    />
                  )}
                  {showEnterEmailPopup && (
                    <UpdateProfileField
                      openSegmentPopup={showEnterEmailPopup}
                      dismissSegmentPopup={this.onCloseEnterEmailPopup}
                      fieldType={fieldType}
                      page={page}
                      handleBtnCTA={(formFieldsState) => this.handleEmailUpdateCTA(formFieldsState)}
                    />
                  )}
                  {showContactInfoPopup && (
                    <ContactInfoPopup
                      openSegmentPopup={showContactInfoPopup}
                      dismissSegmentPopup={this.onCloseContactInfoPopup}
                      restaurantContactNumbers={restaurantContactNumbers}
                    />
                  )}
                  {showPWAInstallPopupFlag && !isRewardAppAvailable && (
                    <InstallAppetizerPopup
                      openSegmentPopup={showPWAInstallPopupFlag}
                      dismissSegmentPopup={this.onClosePWAInstallPopup}
                      restaurantEntityName={restaurantEntityName}
                      restaurantEntityImage={restaurantEntityImage}
                      handleInstallClick={() =>
                        isSafari
                          ? this.handleSafariPWAInstallClick(whitelabelInfoExists, true)
                          : this.handleInstallPWAClick(whitelabelInfoExists)
                      }
                    />
                  )}
                  {showSafariPWAInstallPopupFlag && (
                    <SafariPWAInstallGuide
                      openSegmentPopup={showSafariPWAInstallPopupFlag}
                      dismissSegmentPopup={() => this.setShowSafariPWAInstallPopup(false)}
                    />
                  )}
                  {showAdditionalChargesPopup && (
                    <AdditionalChargesPopup
                      open={showAdditionalChargesPopup}
                      onClose={this.handleCloseAdditionalChargesPopup}
                      isTaxInclusive={isTaxInclusive}
                      additionalCharges={additionalCharges}
                      taxAmount={taxAmount}
                      deliveryAmount={effectiveDeliveryAmount}
                      deliveryDiscount={deliveryDiscount}
                      deliveryCharges={deliveryCharges}
                    />
                  )}
                </>
              ) : (
                <div className="confirmation_authentication-section">
                  <div className="confirmation_authentication-section_text">
                    {orderConfirmationScreenResources.accessPageLoginText}
                  </div>
                  <div className="confirmation_confirmation_authentication-section_login-cta">
                    <Button onClick={this.handleLoginInClick} content={'LOGIN'} />
                  </div>
                </div>
              )}
            </div>
          }
          {showAuthenticationPopup && (
            <AuthenticationPopup
              openSegmentPopup={showAuthenticationPopup}
              dismissSegmentPopup={this.onCloseAuthenticationPopup}
            />
          )}

          {showErrorPopup && (
            <ExceptionComponent
              pageType={pageType}
              openSegmentPopup={showErrorPopup}
              dismissSegmentPopup={this.onCloseExceptionComponent}
              title={get(errorContent, 'title')}
              description={get(errorContent, 'description')}
              buttonCta={get(errorContent, 'buttonCta')}
              handleButtonCta={this.handleErrorBtnCTA}
            />
          )}
          {showInstallAppPopup && (
            <InstallAppPopup
              openSegmentPopup={showInstallAppPopup}
              url={getAppLink}
              dismissSegmentPopup={() => this.setShowInstallAppPopup(false)}
            />
          )}
        </>
      </>
    );
  }
}

export default connect(
  (state) => ({
    appSettings: get(state, 'app.masterData.appSettings', {}),
    restaurant: selectRestaurant(state),
    orderedItems: get(state, 'app.orderedItems', {}),
    orderStatus: get(state, 'app.orderedItems.statusCode', ''),
    restaurantConfig: get(state, 'app.restaurant.restaurantConfig', {}),
    isAssistanceUpdated: get(state, 'app.isAssistanceUpdated', false),
    errorResponse: get(state, 'app.errorResponse', {}),
    loginData: get(state, 'authentication.loginData', {}),
    accessToken: get(state, 'authentication.authData.accessToken', {}),
    selectedTable: get(state, 'app.selectedTable', {}),
    restaurantPhoneNumbers: get(state, 'app.restaurant.restaurantPhoneNumbers', []),
    appStartupInfo: get(state, 'common.appStartupInfo', {}),
    restaurantGroup: get(state, 'app.restaurantGroup', {}),
    progressiveWebApp: get(state, 'app.progressiveWebApp', {}),
    restaurantConfigAdditionalProps: get(
      state,
      'app.restaurant.restaurantConfig.additionalProperties',
      [],
    ),
  }),
  {
    getOrderStatus,
    fetchOrderedItemsAction,
    clearViewCartItems,
    updateAssistanceStatusAction,
    clearApiErrorResponseAction,
    clearFetchOrderedItemsAction,
    updateProfileAction,
    fetchRestaurantDataAction,
    dispatchPreviousSelectedTableAction,
    dispatchVerifiedLocalitiesAction,
    dispatchSelectedAddressAction,
    dispatchUserCart: dispatchUserCartAction,
    clearProgressiveWebAppData: clearProgressiveWebAppDataAction,
    dispatchVisitedRestaurants: dispatchVisitedRestaurantsAction,
    fetchAppStartupInfo: fetchAppStartupInfoAction,
    dispatchProgressiveWebAppData: dispatchProgressiveWebAppDataAction,
  },
)(Confirmation);

const PaymentDetailsRow = ({ payments, paymentMode, orderStatus }) => {
  if (isEmpty(payments)) return null;

  return payments.map((payment) => {
    const paymentStatus = capitalize(get(payment, 'status', ''));
    const transactionSubStatus = get(payment, 'subStatus', '');

    const isCashCardPayment = paymentMode === paymentTypes.loyaltyPaymentTypes.CASHCARD;
    const monetaryAmount = isCashCardPayment
      ? get(payment, 'amount', 0) * cashCardUnitPointMonetaryFactor
      : get(payment, 'amount', 0);

    if (monetaryAmount === 0) return null; // Render nothing for the payment if monetary amount is 0

    const transactionDate = isCashCardPayment
      ? get(payment, 'initiateDate', '')
      : get(payment, 'transactionDate', '');
    const formattedTransactionDate = formatDate(transactionDate, dateTimeFormats.STANDARD);

    const renderablePaymentInfo = {
      amount: `${currencies.INR.symbol} ${monetaryAmount || ''}`,
      paymentMode: getPaymentModeLabel(paymentMode),
      paymentStatus: getPaymentStatus({
        orderStatus,
        paymentType: paymentMode,
        paymentStatus,
        transactionSubStatus,
      }),
      txnRemark: get(payment, 'remark', ''),
      ...(paymentMode !== paymentTypes.POSTPAYMENT // Cash payment won't have an associated transaction date
        ? { transactionDate: formattedTransactionDate }
        : {}),
      ...(isCashCardPayment ? { pointsDebited: get(payment, 'amount', '') } : {}),
      referenceId: get(payment, 'id', ''),
    };

    return (
      <div className="payment-detail row">
        <StatsSection
          label={orderConfirmationScreenResources.paymentDetails.amountLabel}
          value={renderablePaymentInfo.amount}
        />
        <StatsSection
          label={orderConfirmationScreenResources.paymentDetails.paymentMode.label}
          value={renderablePaymentInfo.paymentMode}
        />
        <StatsSection
          label={orderConfirmationScreenResources.paymentDetails.paymentStatus.label}
          value={renderablePaymentInfo.paymentStatus}
        />
        {!!renderablePaymentInfo.txnRemark && !isUUID(renderablePaymentInfo.txnRemark) && (
          <StatsSection
            label={orderConfirmationScreenResources.paymentDetails.paymentStatus.remark}
            value={renderablePaymentInfo.txnRemark}
          />
        )}
        {!!renderablePaymentInfo.transactionDate && (
          <StatsSection
            label={orderConfirmationScreenResources.paymentDetails.transactionDateLabel}
            value={renderablePaymentInfo.transactionDate}
          />
        )}
        {renderablePaymentInfo.pointsDebited !== undefined && (
          <StatsSection
            label={orderConfirmationScreenResources.paymentDetails.pointsDebitedLabel}
            value={renderablePaymentInfo.pointsDebited}
          />
        )}
        {!!renderablePaymentInfo.referenceId && (
          <StatsSection
            label={orderConfirmationScreenResources.paymentDetails.referenceIdLabel}
            value={renderablePaymentInfo.referenceId}
          />
        )}
      </div>
    );
  });
};

const RefundDetailsRow = ({ refunds, refundMode }) => {
  if (isEmpty(refunds)) return null;

  return refunds.map((refund) => {
    const isCashCardRefund = refundMode === refundTypesConfig.loyaltyRefundTypes.CASHCARD;
    const isPrepaidRefund = refundMode === refundTypesConfig.prepaid;
    const refundStatus = capitalize(getRefundStatus(get(refund, 'status', '')));
    const refundRemark = get(refund, 'remark', '');

    const { initiateDate, completeDate } = getRefundStatusUpdateDate(refund, refundMode);
    const formattedRefundInitiateDate = initiateDate
      ? formatDate(initiateDate, dateTimeFormats.STANDARD)
      : '';
    const formattedRefundCompleteDate = completeDate
      ? formatDate(completeDate, dateTimeFormats.STANDARD)
      : '--';

    const monetaryRefundAmount = isCashCardRefund
      ? get(refund, 'amount', 0) * cashCardUnitPointMonetaryFactor
      : get(refund, 'amount', 0);

    if (monetaryRefundAmount === 0) return null; // Render nothing for the refund if monetary refund amount is 0

    const renderableRefundInfo = {
      amount: `${currencies.INR.symbol} ${monetaryRefundAmount || ''}`,
      refundMode: getRefundModeLabel(refundMode),
      refundStatus,
      refundRemark,
      initiateDate: formattedRefundInitiateDate,
      completeDate: formattedRefundCompleteDate,
      ...(isCashCardRefund ? { pointsCredited: get(refund, 'amount', '') } : {}),
      referenceId: get(refund, 'id', ''),
      ...(isPrepaidRefund ? { arn: get(refund, 'arn', '') } : {}), // Acquirer Reference Number generated only for online payments on production webapp
    };

    return (
      <div className="refund-detail row">
        <StatsSection
          label={orderConfirmationScreenResources.refundDetails.amountLabel}
          value={renderableRefundInfo.amount}
        />
        <StatsSection
          label={orderConfirmationScreenResources.refundDetails.refundMode.label}
          value={renderableRefundInfo.refundMode}
        />
        <StatsSection
          label={orderConfirmationScreenResources.refundDetails.refundStatus.label}
          value={renderableRefundInfo.refundStatus}
        />
        {!!renderableRefundInfo.refundRemark && !isUUID(renderableRefundInfo.refundRemark) && (
          <StatsSection
            label={orderConfirmationScreenResources.refundDetails.refundStatus.remark}
            value={renderableRefundInfo.refundRemark}
          />
        )}
        {!!renderableRefundInfo.initiateDate && (
          <StatsSection
            label={orderConfirmationScreenResources.refundDetails.initiateDateLabel}
            value={renderableRefundInfo.initiateDate}
          />
        )}
        <StatsSection
          label={orderConfirmationScreenResources.refundDetails.completeDateLabel}
          value={renderableRefundInfo.completeDate}
        />
        {renderableRefundInfo.pointsCredited !== undefined && (
          <StatsSection
            label={orderConfirmationScreenResources.refundDetails.pointsCreditedLabel}
            value={renderableRefundInfo.pointsCredited}
          />
        )}
        {!!renderableRefundInfo.referenceId && (
          <StatsSection
            label={orderConfirmationScreenResources.refundDetails.referenceIdLabel}
            value={renderableRefundInfo.referenceId}
          />
        )}
        {!!renderableRefundInfo.arn && (
          <StatsSection
            label={orderConfirmationScreenResources.refundDetails.arnLabel}
            value={renderableRefundInfo.arn}
          />
        )}
      </div>
    );
  });
};

const StatsSection = ({ label = '', value = null }) => (
  <div className="stats-section">
    <span className="text">{label}</span>
    <span className="value">{value}</span>
  </div>
);
